import { useEffect } from 'react';

import { GoalsIndividualClickThroughIntent } from 'Deer/intent/Goals/GoalsIndividualClickThroughIntent';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const IndividualsGoals = ({ cohort }: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort }));
  }, [cohort]);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      dispatch(setSelectedView({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <GoalsIndividualClickThroughIntent />;
};

export default IndividualsGoals;
